import { SovosBox, SovosButton, SovosTypography } from "mosaic-react";
import React from "react";

const EmptyMappingContexts = ({ i18n, onRetry }) => (
    <SovosBox role="status" sx={{ mb: 2 }}>
        <SovosTypography color="text.secondary" variant="body2">
            {i18n`No mapping countries are configured for this project.`}
        </SovosTypography>
        <SovosButton onClick={onRetry} size="small" variant="text">
            {i18n`Retry`}
        </SovosButton>
    </SovosBox>
);

export default EmptyMappingContexts;
